import * as angular from 'angular';

import { INgRedux } from '../redux';
import { AppService } from '../services/app-service';
import * as fromStore from '../store';

interface IAppState {
    progress: boolean;
    progressText: string;
}

interface IAppScope extends angular.IScope, IAppState {
    client: number;
    navbarOpen: boolean;
    toggleNavbar: () => void;
    changeClient: () => void;
    invokeAction: () => void;
}

export class AppController implements angular.IController {
    static readonly $inject = ['$scope', '$window', '$ngRedux', 'fcAppService'];

    private navbar: JQuery;

    constructor(
        private readonly scope: IAppScope,
        private readonly window: angular.IWindowService,
        private readonly ngRedux: INgRedux,
        private readonly appService: AppService
    ) {
        this.mapState = this.mapState.bind(this);

        this.scope.toggleNavbar = this.toggleNavbar.bind(this);
        this.scope.changeClient = this.changeClient.bind(this);
        this.scope.invokeAction = this.invokeAction.bind(this);

        // Listen for any redirect or form changes
        this.ngRedux.subscribe(() => {
            const state = this.ngRedux.getState();
            const redirect = fromStore.getAppRedirect(state);

            if (redirect) {
                this.window.location.href = redirect;
            }
        });

        // Configure the redux state and action binding
        const connect = this.ngRedux.connect(this.mapState);
        const unsubscribe = connect(this.scope);

        this.scope.$on('$destroy', unsubscribe);
    }

    private mapState(state: fromStore.ICoreState): IAppState {
        return {
            progress: fromStore.getAppProgress(state),
            progressText: fromStore.getAppProgressText(state)
        };
    }

    private toggleNavbar(open: boolean): void {
        // Initialize the element on demand
        if (!this.navbar) {
            this.navbar = angular.element('#fc-navbar');
        }

        // A dirty hack to avoid a foundation bug where is-closed is set on transition end
        // Double clicking the toggle gets the navbar state out of whack
        let method = null;

        if (open && this.navbar.is('.is-closed')) {
            method = 'open';
        } else if (!open && this.navbar.is('.is-open')) {
            method = 'close';
        }

        if (method) {
            this.scope.navbarOpen = open;
            this.navbar.foundation(method);
        }
    }

    private changeClient(id: number, controllerName: string, route: string): void {
        const progressAction: fromStore.ISetShowProgressAction = {
            type: fromStore.AppActionType.SET_SHOW_PROGRESS,
            show: true,
            redirect: `${route}?companyId=${id}&controllerName=${controllerName}`
        };

        this.appService.changeClient(id);

        this.ngRedux.dispatch(progressAction);
    }

    private invokeAction(name: string): void {
        this.appService.invokeAction(name);
    }
}
